import AppSystemResourceListResultModel from '../../generated/types/model/resource/AppSystemResourceListResultModel';

export default class AppSystemResourceListResultViewModel extends AppSystemResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
